import { counterActions } from "@/entities/counter";
import { filterActions } from "@/entities/filter";
import { filterAppsActions } from "@/entities/filterApps";
import { filterAppsDataActions } from "@/entities/filterAppsData";
import { inputSearchActions } from "@/entities/inputSearch";
import { modalFiltersActions } from "@/entities/modalFilters/model/slice/modalFiltersSlice";
import { sortByCategoriesActions } from "@/entities/sortByCategories";
import { useDispatch } from "react-redux";

export const useResetFilters = (func?: () => void) => {
  const dispatch = useDispatch();

  const resetAllFilters = () => {
    dispatch(sortByCategoriesActions.setSortBy("None"));
    dispatch(sortByCategoriesActions.setGroup("None"));
    dispatch(sortByCategoriesActions.setIndexGroup(0));
    dispatch(filterAppsActions.setPaywall(""));
    dispatch(filterAppsActions.resetOscGte());
    dispatch(filterAppsActions.resetOscLte());
    dispatch(filterAppsActions.setCategories(""));
    dispatch(filterAppsActions.setAppCollections(""));

    dispatch(filterActions.deactivateCategory());
    dispatch(filterActions.deactivateAppCollections());
    dispatch(filterAppsActions.resetRevenueGte());

    dispatch(filterAppsActions.resetRevenueLte());
    dispatch(filterAppsActions.resetDownloadGte());
    dispatch(filterAppsActions.resetDownloadLte());
    dispatch(filterAppsActions.resetRevInstallRateGte());
    dispatch(filterAppsActions.resetRevInstallRateLte());
    dispatch(filterAppsActions.setFilterSort("revenue"));
    dispatch(sortByCategoriesActions.setIndexSort(4)); // 4 is revenue
    dispatch(filterAppsActions.setFilterGroup(""));
    dispatch(filterAppsActions.setIsPaywallOnly(false));

    dispatch(filterAppsActions.deactiveCategories());
    dispatch(filterAppsActions.deactivePaywall());
    dispatch(filterAppsActions.deactiveOnboarding());
    dispatch(filterAppsActions.deactiveInstalls());
    dispatch(filterAppsActions.deactiveRevenue());
    dispatch(filterAppsActions.deactiveContain());
    dispatch(filterAppsActions.setActiveModalIndexCategories([]));
    dispatch(filterAppsActions.setActiveModalIndexPaywall(null));
    dispatch(filterAppsActions.deactiveMagic());
    dispatch(filterAppsActions.deactiveLabelled());
    dispatch(filterAppsActions.setAvsTags(""));
    dispatch(filterAppsActions.setButtonRevenue(null));
    dispatch(filterAppsActions.setButtonInstalls(null));
    dispatch(filterAppsActions.setButtonOnboarding(null));
    dispatch(filterAppsActions.setOnly("not_hidden"));
    dispatch(filterAppsActions.setSelectedDataMax("Max"));
    dispatch(filterAppsActions.setSelectedDataMin("Min"));
    dispatch(filterAppsActions.setSelectedDataRangeMax("Max"));
    dispatch(filterAppsActions.setSelectedDataRangeMin("Min"));
    dispatch(filterAppsActions.deactiveUpdateDate());
    dispatch(filterAppsActions.deactiveReleaseDate());
    dispatch(filterAppsActions.setReleasedFrom(""));
    dispatch(filterAppsActions.setReleasedTo(""));
    dispatch(filterAppsActions.setUpdatedFrom(""));
    dispatch(filterAppsActions.setUpdatedTo(""));
    dispatch(counterActions.clearArray());

    dispatch(filterAppsActions.setActiveButtonReleaseDate(null));
    dispatch(filterAppsActions.setActiveButtonUpdateDate(null));
    dispatch(modalFiltersActions.setIsReleaseDateOpen(false));
    dispatch(modalFiltersActions.setIsUpdateDateOpen(false));
    dispatch(sortByCategoriesActions.setIsActiveGroup(false));
    dispatch(sortByCategoriesActions.setIsActiveSort(false));
    dispatch(inputSearchActions.deactiveOCR());
    dispatch(counterActions.setCount(0));

    dispatch(filterAppsActions.resetPageFilter());
    dispatch(filterAppsDataActions.resetFilterAppDataSorted());
    dispatch(filterAppsDataActions.resetFilterAppData());
    dispatch(filterAppsDataActions.resetFilterAppDataSortedAll());
    dispatch(filterAppsActions.resetPageFilterSidebar());

    dispatch(filterAppsActions.resetFlowsFilter());
    func?.();
  };

  return { resetAllFilters };
};
